import i18n from "../i18n";

const Recipes = (app) => {
  app
    .post("/recipes/create", async ({ api, flash, req, res }) => {
      const { body, files } = req;

      let modifiedIngredients = [];
      const steps = body.step ? body.step : body.steps ? body.steps : [];
      const ingredients = body.ingredient
        ? body.ingredient
        : body.ingredients
        ? body.ingredients
        : [];

      if (Array.isArray(ingredients)) {
        ingredients.forEach((elementname, index) => {
          if (elementname.length > 0) {
            const obj = { name: elementname, quantity: body.qty[index] };
            modifiedIngredients.push(obj);
          }
        });
      } else {
        modifiedIngredients = [
          { name: ingredients.toString(), quantity: body.qty.toString() },
        ];
      }

      const recipe = {
        name: body.name,
        foodType: body.foodType,
        prepTime: body.prepTime.toString(),
        difficulty: body.difficulty,
        dietaryRestrictions:
          body.dietaryRestrictions.length === 0
            ? null
            : body.dietaryRestrictions.split(","),
        description: body.description.toString(),
        macrosBase: body.macrosBase,
        nutrients: {
          proteins: body.proteins ? body.proteins.toString() : "0",
          carbs: body.carbs ? body.carbs.toString() : "0",
          fats: body.fats ? body.fats.toString() : "0",
          fibers: body.fibers ? body.fibers.toString() : "0",
        },
        steps: Array.isArray(steps)
          ? steps.filter(function (element) {
              return element.trim() != "";
            })
          : steps.toString().split(),
        ingredients: modifiedIngredients,
        servings: body.servings,
        widget: body.widget,
      };

      const response = await api("recipe", {
        method: "POST",
        body: recipe,
        files,
      });

      const { ok, statusText = undefined } = response;

      if (!ok) {
        const errorMessage = statusText || i18n.t("coaching-portal:recipesActions.errorOccurred");
        flash("error", errorMessage);
        return res.backDontScroll();
      }

      flash("success", i18n.t("coaching-portal:recipesActions.successfullyCreated"));

      res.refreshWith({ submited: true }, { url: "back", hash: "#_" });
    })
    .post("/recipes/save/:id", async ({ api, flash, req, res }) => {
      const { body, files } = req;

      let modifiedIngredients = [];
      if (Array.isArray(body.ingredient)) {
        body.ingredient.forEach((elementname, index) => {
          if (elementname.length > 0) {
            const obj = { name: elementname, quantity: body.qty[index] };
            modifiedIngredients.push(obj);
          }
        });
      } else if (body.ingredient) {
        modifiedIngredients = [
          { name: body.ingredient.toString(), quantity: body.qty.toString() },
        ];
      }

      const recipe = {
        name: body.name,
        foodType: body.foodType,
        prepTime: body.prepTime && body.prepTime.toString(),
        difficulty: body.difficulty,
        dietaryRestrictions:
          body.dietaryRestrictions.length === 0
            ? null
            : body.dietaryRestrictions.split(","),
        description: body.description ? body.description.toString() : false,
        macrosBase: body.macrosBase,
        nutrients: {
          proteins: body.proteins ? body.proteins.toString() : "0",
          carbs: body.carbs ? body.carbs.toString() : "0",
          fats: body.fats ? body.fats.toString() : "0",
          fibers: body.fibers ? body.fibers.toString() : "0",
        },
        steps: Array.isArray(body.step)
          ? body.step.filter(function (element) {
              return element.trim() != "";
            })
          : body.step.toString().split(),
        ingredients: modifiedIngredients,
        servings: body.servings,
      };

      const response = await api(`recipe/${req.params.id}`, {
        method: "PUT",
        body: recipe,
        files,
      });

      const { ok, statusText = undefined } = response;

      if (!ok) {
        const errorMessage = statusText || i18n.t("coaching-portal:recipesActions.errorOccurred");
        flash("error", errorMessage);
        return res.backDontScroll();
      }

      flash("success", i18n.t("coaching-portal:recipesActions.successfullyUpdated"));

      res.refreshWith({}, { url: "back", hash: "#_" });
    })
    .get("/recipes/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`recipe/${id}`, {
        method: "DELETE",
      });

      flash("success", i18n.t("coaching-portal:recipesActions.successfullyDeleted"));

      res.backDontScroll();
    })
    .post("/recipes/status/:id", async ({ api, assert, flash, req, res }) => {
      const {
        body: { status },
        params: { id },
      } = req;
      const verbs = {
        draft: "unpublish",
        published: "publish",
      };

      assert(status, 400, i18n.t("coaching-portal:recipesActions.statusRequired"));
      assert(id, 400, i18n.t("coaching-portal:recipesActions.recipeIdRequired"));

      const verb = verbs[status];

      const response = await api(`recipe/${id}`, {
        method: "PUT",
        body: { status },
      });

      const { ok, statusText = undefined } = response;

      if (!ok) {
        const errorMessage = statusText || i18n.t("coaching-portal:recipesActions.errorOccurred");
        flash("error", errorMessage);
        return res.backDontScroll();
      }

      flash("success", verb === "publish" ? i18n.t("coaching-portal:recipesActions.successfullyPublished") : i18n.t("coaching-portal:recipesActions.successfullyUnpublished"));

      res.refreshWith({}, { url: "back", hash: "#_" });
    })
    .post("/recipes/reorder", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      assert(
        body.orderedRecipes,
        400,
        i18n.t("coaching-portal:recipesActions.provideOrderArray")
      );

      await api("recipe-reorder", {
        method: "PUT",
        body,
      });

      flash("success", i18n.t("coaching-portal:recipesActions.successfullyReordered"));
      res.backDontScroll();
    });
};

export default Recipes;
